import React from "react";
import { StyleSheet, View } from "react-native";
import Button from "../../button/Button";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens } from "@voltmoney/schema";
const CoBorrowerKycFooter = ({ nextAction, addCoBorrower, triggerAction, allReKYCsDone }) => {
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: styles.buttonContainer },
            React.createElement(Button, { id: "bt_coBorrowerDetails_addCoBorrower", type: ButtonTypeTokens.LargeSoftFilled, label: 'Add another co-borrower', width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, labelColor: ColorTokens.Primary_100, onPress: () => {
                    if (addCoBorrower) {
                        triggerAction(addCoBorrower);
                    }
                } })),
        React.createElement(View, { style: styles.buttonContainer },
            React.createElement(Button, { id: "bt_coBorrowerDetails_nextStep", type: allReKYCsDone ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline, label: 'Continue to next step', width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                    if (nextAction) {
                        triggerAction(nextAction);
                    }
                } }))));
};
const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        bottom: 0,
        paddingHorizontal: 16,
        paddingBottom: 24,
        backgroundColor: 'white',
        zIndex: 1,
        width: '100%',
        borderColor: '#F1F3F5',
        borderWidth: 1,
        elevation: 20,
    },
    buttonContainer: {
        width: '100%',
        borderRadius: 1000,
        paddingTop: 16,
    },
});
export default CoBorrowerKycFooter;
